// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_landing_disclaimer_full_text = /** @type {(inputs: {}) => string} */ () => {
	return `As it stands right now, MochiMemo is only a proof of concept and is actually a research project. Meaning, it's mostly used to explore the possibilities of ai and language learning. It's not meant to be used as a replacement for traditional methods. It may or may not provide inaccurate information or answers even when it tries its best to consult to the internet for factual information. Please always take the AI's responses with a grain of salt.`
};

const id_landing_disclaimer_full_text = /** @type {(inputs: {}) => string} */ () => {
	return `Saat ini, MochiMemo hanyalah sebuah bukti konsep dan sebenarnya merupakan proyek penelitian. Artinya, sebagian besar digunakan untuk mengeksplorasi kemungkinan kecerdasan buatan dan pembelajaran bahasa. Ini tidak dimaksudkan untuk digunakan sebagai pengganti metode tradisional. Ini mungkin atau mungkin tidak memberikan informasi atau jawaban yang tidak akurat bahkan ketika mencoba yang terbaik untuk berkonsultasi dengan internet guna mendapatkan informasi faktual. Harap selalu tanggapi respons AI dengan skeptis.`
};

const ja_landing_disclaimer_full_text = /** @type {(inputs: {}) => string} */ () => {
	return `現時点では、MochiMemoは概念実証段階であり、実際には研究プロジェクトです。つまり、主にAIと言語学習の可能性を探るために使用されます。従来の学習方法の代替として使用されるものではありません。インターネットで事実情報を検索しようと最善を尽くしても、不正確な情報や回答が提供される場合があります。AIの回答は常に鵜呑みにしないでください。`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "id" | "ja" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const landing_disclaimer_full_text = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.landing_disclaimer_full_text(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("landing_disclaimer_full_text", locale)
	if (locale === "en") return en_landing_disclaimer_full_text(inputs)
	if (locale === "id") return id_landing_disclaimer_full_text(inputs)
	return ja_landing_disclaimer_full_text(inputs)
};
export { landing_disclaimer_full_text as "landing.disclaimer.full_text" }